import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import "./mobile-nav.css"

const MobileNav = () => {
  return (
    <section className="hd-MobileNav">
      <div className="hd-MobileNav_Inner lyt-Container">
        <div className="hd-MobileNav_Body">
          <nav className="hd-MobileNav_Items">
            <div className="hd-MobileNav_Item">
              <AniLink
                cover
                bg="#22242b"
                direction="up"
                to="/"
                className="hd-MobileNav_Link"
              >
                Home
              </AniLink>
            </div>

            <div className="hd-MobileNav_Item">
              <AniLink
                cover
                bg="#22242b"
                direction="up"
                to="/services"
                className="hd-MobileNav_Link"
              >
                Services
              </AniLink>
            </div>

            <div className="hd-MobileNav_Item">
              <AniLink
                cover
                bg="#22242b"
                direction="up"
                to="/process"
                className="hd-MobileNav_Link"
              >
                Process
              </AniLink>
            </div>

            <div className="hd-MobileNav_Item">
              <AniLink
                cover
                bg="#22242b"
                direction="up"
                to="/contact"
                className="hd-MobileNav_Link"
              >
                Contact
              </AniLink>
            </div>
          </nav>
        </div>
      </div>
    </section>
  )
}

export default MobileNav
